import mycarsSrpVdp from './utils/mycarsSrpVdp';

export default {
	events: {
		widgetUserEvent: [
			...mycarsSrpVdp.widgetUserEvent,
			{
				logic: [
					{
						eventName: 'DR_TRADEIN_OPENED'
					}
				],
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.general]]',
						{
							feature_category:
								'trade in form: vehicle details step: page load',
							event_name:
								'engagement feature interaction: trade in form: vehicle details step: page load',
							event_engagement_feature_interaction: 'true',
							event_trade_in_form_vehicle_details_step_page_load:
								'true',
							site_events_array:
								'engagement_feature_interaction, trade_in_form_vehicle_details_step_page_load',
							site_event_name: [
								'engagement_feature_interaction',
								'trade_in_form_vehicle_details_step_page_load'
							]
						}
					]
				}
			},
			{
				logic: [
					{
						eventName: 'DR_TRADEIN_ESTIMATE_DISPLAYED'
					}
				],
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.general]]',
						{
							feature_category:
								'trade in form: submit lead form step: success',
							event_name:
								'engagement feature interaction: trade in form: submit lead form step: success',
							event_engagement_feature_interaction: 'true',
							event_trade_in_submit_lead_form_step_success:
								'true',
							site_events_array:
								'engagement_feature_interaction, trade_in_submit_lead_form_step_success',
							site_event_name: [
								'engagement_feature_interaction',
								'trade_in_submit_lead_form_step_success'
							]
						}
					]
				}
			},
			{
				logic: ({
					eventData: { eventName, sourceData: { leadContext } = {} }
				}) =>
					eventName === 'DR_SUBMIT_OFFR_BTTN_CLICKED' &&
					leadContext === 'CREDITAPP',
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.general]]',
						{
							feature_category:
								'credit application form: lead form step 1: page load',
							event_name:
								'engagement feature interaction: credit application form: lead form step 1: page load',
							event_engagement_feature_interaction: 'true',
							event_credit_application_form_lead_form_step_1_page_load:
								'true',
							site_events_array:
								'engagement_feature_interaction, credit_application_form_lead_form_step_1_page_load',
							site_event_name: [
								'engagement_feature_interaction',
								'credit_application_form_lead_form_step_1_page_load'
							]
						}
					]
				}
			},
			{
				logic: [
					{
						eventName: 'DR_CREDIT_APP_SUBMITTED'
					}
				],
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.general]]',
						{
							feature_category:
								'credit application form: submit form step 6: success',
							event_name:
								'engagement feature interaction: credit application form: submit form step 6: success',
							event_engagement_feature_interaction: 'true',
							event_credit_application_submit_form_step_6_success:
								'true',
							site_events_array:
								'engagement_feature_interaction, credit_application_submit_form_step_6_success',
							site_event_name: [
								'engagement_feature_interaction',
								'credit_application_submit_form_step_6_success'
							]
						}
					]
				}
			},
			{
				logic: ({
					eventData: { eventName, sourceData: { leadContext } = {} }
				}) =>
					eventName === 'DR_SUBMIT_OFFR_BTTN_CLICKED' &&
					leadContext !== 'CREDITAPP',
				payload: ({ eventData: { widgetState } }) => ({
					shared: [
						'[[mapping.configuration.sharedPayloads.general]]',
						{
							feature_category: `payment calculator: ${widgetState}: Send Offer`,
							event_name: `engagement feature interaction: payment calculator: ${widgetState}: Send Offer`,
							event_engagement_feature_interaction: 'true',
							[`event_payment_calculator_${widgetState}_send_offer`]:
								'true',
							site_events_array: `engagement_feature_interaction, payment_calculator_${widgetState}_send_offer`,
							site_event_name: [
								'engagement_feature_interaction',
								`payment_calculator_${widgetState}_send_offer`
							]
						}
					]
				})
			},
			{
				logic: ({
					eventData: { eventName, sourceData: { leadContext } = {} }
				}) =>
					eventName === 'DR_OFFER_SUBMISSION_CLICKED' &&
					leadContext === 'DealStarter',
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.general]]',
						{
							feature_category:
								'payment calculator: Submit Your Offer',
							event_name:
								'engagement feature interaction: payment calculator: Submit Your Offer',
							event_engagement_feature_interaction: 'true',
							event_payment_calculator_submit_your_offer: 'true',
							site_events_array:
								'engagement_feature_interaction, payment_calculator_submit_your_offer',
							site_event_name: [
								'engagement_feature_interaction',
								'payment_calculator_submit_your_offer'
							]
						}
					]
				}
			},
			{
				logic: [
					{
						eventName: 'DR_NAVIGATE_TO_INCENTIVES'
					}
				],
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.general]]',
						{
							feature_category:
								'payment calculator: Calculate your Payment: success',
							event_name:
								'engagement feature interaction: payment calculator: Calculate your Payment: success',
							event_engagement_feature_interaction: 'true',
							event_payment_calculator_calculate_your_payment_success:
								'true',
							site_events_array:
								'engagement_feature_interaction, payment_calculator_calculate_your_payment_success',
							site_event_name: [
								'engagement_feature_interaction',
								'payment_calculator_calculate_your_payment_success'
							]
						}
					]
				}
			}
		]
	}
};
